import React from 'react';
import './AdminOrderTable.css';
import {Link} from 'react-router-dom';
const AdminOrderTable =(props)=>{

    
        const handle_state=[['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','trash','trash','trash','trash','trash','trash','trash','trash','trash','trash','trash'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced']]
         const paramsordernumber =props.paramsordernumber
        
               return(
                   
                <div className="col-md-4 px-2 py-3 OrderTable">
                                <p className="col-6 mt-2 p-0 fontsize10"> Orders</p>

                                <div className="tableDetails border shadow mx-auto">
                                <p className="col-6 m-3 p-0 fontsize4">All Orders</p>

                                    <div className="thead-light fontsize12 text-muted">
                                        <div className="headertable p-3 border">
                                            <p className="m-0">ORDER BY NAME</p>
                                        </div>
                                    </div>
                                    <div className="fontsize12">
                                        {
                                            props.state.dataorders.map((x, i) => (
                                                <div className={"p-3 border-bottom "+(props.state.ordernumber  ===x.ordernumber ? 'active' : '')}  key={i}>
                                                <div className="row">
                                                    <div className="col-7">
                                                        <Link to={"/Admin/OrderDetail/"+x.ordernumber}  onClick={() =>  props.getorderid(x.ordernumber)}><p>{x.reciver.name} <br /> {x.ordernumber}</p></Link>
                                                    </div>
                                                    <div className="col-5 p-1">
                                                        <span className={"badge-pill "+handle_state[x.failedstatus][x.status]}>{handle_state[x.failedstatus][x.status]}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            ))
                                        }
                                        
                                    </div>
                                </div>
                            </div>
        )
    
}
export default AdminOrderTable;